module.exports = __webpack_public_path__ + "img/zizhi14.ed57b885.png";